import { Button } from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { BiLinkExternal } from "react-icons/bi";
import { FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FormatedCategory } from ".";
import Modal, { SimpleModalControls } from "../../../components/Modal"
import { getAxiosInstance } from "../../../utils/axiosInstance";

interface CategoryOptionModalProps extends SimpleModalControls {
  data: FormatedCategory | null
};

const CategoryOptionModal = (props: CategoryOptionModalProps) => {
  const { t } = useTranslation("translations");
  const nav = useNavigate();
  
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  
  const deleteCategory = async () => {
    setIsDeleting(true)
    try {
      await getAxiosInstance().delete("/Categories", { params: { id: props.data?.id }});
      toast.success(t("CATEGORY_DELETED_SUCCESSFULLY"), { position: toast.POSITION.BOTTOM_RIGHT});
      props.onClose();
    } catch (e) {
      toast.error(t("SOMETHING_WENT_WRONG"), { position: toast.POSITION.BOTTOM_RIGHT});
    } finally {
      setIsDeleting(false);
    }
  }
  
  return (
    <Modal
      header={t("CATEGORY_OPTION_MODAL_TITLE")}
      onClose={props.onClose}
      isOpen={props.isOpen}
    >
      <div className="w-full">
        <Button
          colorScheme='red'
          className="w-full"
          isLoading={isDeleting}
          loadingText={t("DELETING_CATEGORY")}
          leftIcon={<FaTrash />}
          onClick={() => deleteCategory()}
        >
          {t("DELETE_CATEGORY")}
        </Button>
        <Button
          colorScheme='green'
          className="w-full mt-5"
          leftIcon={<BiLinkExternal />}
          onClick={() => nav(`/categories/${props.data?.id}`)}
        >
          {t("GO_TO_CATEGORY_PAGE")}
        </Button>
      </div>
    </Modal>
  )
}

export default CategoryOptionModal;